<template>
  <div
    class="scrollContainer"
    v-if="files.length > 0"
    :class="
      dataHistoryConversation && dataHistoryConversation.length > 0
        ? ''
        : 'bgGray'
    "
  >
    <!-- 滑动内容区 -->
    <div class="scrollContent">
      <div v-for="(item, index) in files" :key="index">
        <!--    历史会话拿到的数据展示    -->
        <div
          class="item"
          v-if="dataHistoryConversation && dataHistoryConversation.length > 0"
        >
          <!--   图片类展示小图     -->
          <div class="image" v-if="item.type == 'image'">
            <img
              class="imageUrl"
              :src="item.url"
              @click="getPreviewIndex(item.id)"
            />
          </div>
          <!--   video类展示封面图     -->
          <div
            class="video"
            v-else-if="item.type == 'video' && item.load != 'error'"
          >
            <!--    预览图     -->
            <img
              class="imageUrl"
              :src="item.coverImage"
              @click="previewItem(item)"
            />
          </div>
          <!--   文件类展示文件名，后缀，文件大小,及上传进度    -->
          <div class="file" v-else @click="previewItem(item)">
            <div class="fileName">{{ item.filename }}</div>
            <div class="fileInfo">{{ item.mime_type }} · {{ item.size }}</div>
          </div>
        </div>
        <!--   本地文件展示     -->
        <div class="item" v-else>
          <!--   图片类展示小图     -->
          <div class="image" v-if="item.type == 'image'">
            <img
              class="imageUrl"
              :src="item.url"
              @click="getPreviewIndex(item.id)"
            />
            <!--    删除按钮     -->
            <img
              class="delete"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/icon_file_delete.svg"
              @click="removeFile(item.id)"
            />
          </div>

          <!--   video类展示封面图     -->
          <div
            class="video"
            v-else-if="item.type == 'video' && item.load != 'error'"
          >
            <!--    预览图     -->
            <img class="imageUrl" :src="item.coverImage" />
            <img
              class="playFill"
              @click="previewItem(item)"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/icon_play_fill.png"
            />
            <!--    视频的时长     -->
            <div class="duration">{{ formatTime(item.videoDuration) }}</div>
            <!--    删除按钮     -->
            <img
              class="delete"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/icon_file_delete.svg"
              @click="removeFile(item.id)"
            />
          </div>

          <!--   文件类展示文件名，后缀，文件大小,及上传进度    -->
          <div class="file" v-else @click="previewItem(item)">
            <div class="fileName">{{ item.file.name }}</div>
            <div class="fileInfo">
              {{ getFileExtension(item.file.name) }} ·
              {{ formatFileSize(item.file.size) }}
            </div>
            <!--    删除按钮     -->
            <img
              class="delete"
              src="https://appbkai.oss-cn-shanghai.aliyuncs.com/vue-ai-chat/icon_file_delete.svg"
              @click="removeFile(item.id)"
            />
            <!-- 饼状图展示上传进度 -->
            <svg
              class="upload"
              v-if="0 < item.progress && item.progress < 100"
              width="12"
              height="12"
              viewBox="-1 -1 2 2"
              style="transform: rotate(0deg)"
            >
              <!-- 已上传部分 -->
              <path
                :d="getPath(0, item.progress)"
                fill="currentColor"
                stroke="#296DFE"
                stroke-width="0.05"
                :style="{ color: '#296DFE' }"
              />
              <!-- 剩余未上传部分 -->
              <path
                :d="getPath(item.progress, 100)"
                fill="currentColor"
                stroke="#296DFE"
                stroke-width="0.05"
                :style="{ color: '#FFFFFF' }"
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
    <!--  图片预览  -->
    <van-image-preview
      get-container="#app"
      v-model="showPreview"
      :images="images"
      :start-position="previewIndex"
    >
    </van-image-preview>
    <!-- 视频预览   -->
    <van-popup get-container="#app" v-model="showVideoPopup">
      <video :src="videoUrl" controls style="width: 100%; height: auto"></video>
    </van-popup>
    <!-- 音频预览   -->
    <van-popup get-container="#app" v-model="showAudioPopup">
      <div
        v-if="audioUrl"
        style="background: #fff; border-radius: 12px; padding: 12px 20px"
      >
        <div style="margin-bottom: 12px">音频预览：</div>
        <audio :src="audioUrl" controls></audio>
      </div>
    </van-popup>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "filePreview",
  props: {
    //接收到的文件数据
    receivedFileData: {
      type: Array,
      default: () => [],
    },
    //会话里拿到的文件
    dataFileConversation: {
      type: Array,
      default: () => [],
    },
    //历史会话拿到的文件
    dataHistoryConversation: {
      type: Array,
      default: () => [],
    },
    //aiAppCode
    aiAppCode: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      //文件上传需要携带
      ai_app_code: "dxlc_lz_app",
      //选取的文件数据
      files: [],
      //待预览的图片
      images: [],
      //上传成功的文件，push到会话列表中的需要完成状态
      completeFiles: [],
      //文件上传成功返回的待上传文件
      filesWaitUpload: [],
      // 存储每个文件对应的AbortController实例
      uploadControllers: [],
      // 最大可上传文件数
      maxUploadCnt: 3,
      //是否展示预览
      showPreview: false,
      //图片预览的index
      previewIndex: 0,
      //是否展示视频的预览
      showVideoPopup: false,
      //视频预览的资源文件
      videoUrl: "",
      //音频预览
      showAudioPopup: false,
      //音频预览的资源文件
      audioUrl: "",
    };
  },
  mounted() {},
  watch: {
    //文件上传获取的文件
    receivedFileData: {
      handler(newValue) {
        this.maxUploadCnt = this.$store.getters.maxUploadCnt;
        if (newValue && newValue.length > 0) {
          // 检查是否已经处理过这些文件
          const isNewData = newValue.some(
            (item, index) =>
              !this.files[index] || this.files[index].id !== item.id
          );
          if (!isNewData) {
            return;
          }
          //放到预览区域展示
          for (const i in newValue) {
            const file = newValue[i];
            //如果存在同一个id，不处理
            if (this.files.findIndex((item) => item.id === file.id) > -1) {
              return;
            }
            if (file.type.startsWith("image")) {
              this.images.push(file.url);
            }
            if (file.type.startsWith("video")) {
              this.getVideoCoverAndDuration(file);
            }
            if (this.files.length >= this.maxUploadCnt) {
              this.$toast("最多" + this.maxUploadCnt + "个文件");
            }
            if (this.files.length < this.maxUploadCnt) {
              this.files.push(file);
              //先上传文件到服务器
              this.uploadFile(file);
            }
          }
        } else {
          this.files = [];
          this.images = [];
          this.filesWaitUpload = [];
          this.completeFiles = [];
        }
      },
      immediate: true, // 立即以表达式的当前值触发回调
    },
    //历史会话列表中的文件展示
    dataHistoryConversation: {
      handler(newValue) {
        this.files = [];
        this.images = [];
        if (newValue && newValue.length > 0) {
          for (const i in newValue) {
            const file = newValue[i];
            //服务器端拿到的文件列表
            if (file.mime_type) {
              if (file.mime_type.startsWith("image")) {
                this.files.push({ type: "image", url: file.url, id: file.id });
                this.images.push(file.url);
              } else {
                let item = {};
                item.type = file.mime_type;
                item.url = file.url;
                item.filename = file.filename;
                item.mime_type = this.extractStr(file.filename);
                item.size = this.formatFileSize(file.size);
                item.id = file.id;
                item.transfer = "remote";
                this.files.push(item);
              }
            } else if (file.type) {
              //本地push到会话列表中的文件列表
              if (file.type.startsWith("image")) {
                this.files.push({ type: "image", url: file.url, id: file.id });
                this.images.push(file.url);
              } else {
                let item = {};
                item.type = file.type;
                //需要预览的文件
                item.file = file.file;
                item.filename = file.file.name;
                item.mime_type = this.getFileExtension(file.file.name);
                item.size = this.formatFileSize(file.file.size);
                item.id = file.id;
                item.transfer = "local";
                this.files.push(item);
                if (file.type.startsWith("video")) {
                  this.getVideoCoverAndDuration(file);
                }
              }
            }
          }
        } else {
          this.files = [];
          this.images = [];
        }
      },
      immediate: true, // 立即以表达式的当前值触发回调
    },
    aiAppCode: {
      handler(newValue) {
        if (newValue) {
          this.ai_app_code = newValue;
        }
      },
      immediate: true, // 立即以表达式的当前值触发回调
    },
  },
  methods: {
    //格式化file的大小
    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";
      const k = 1024,
        dm = 2,
        sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
        i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    //获取文件的前缀
    getFileExtension(filename) {
      const match = filename.match(/\.([^.]+)$/);
      if (match) {
        return match[1];
      }
      return ""; // 如果没有找到合适的后缀，返回空字符串
    },
    //截取字符串
    extractStr(str) {
      const arr = str.split(".");
      return arr[arr.length - 1];
    },
    //点击delete按钮，删除对应的文件
    removeFile(id) {
      console.log("点击了删除按钮");
      // 移除对应的文件 ok
      const indexId = this.files.findIndex((item) => item.id === id);
      if (indexId > -1) {
        this.files.splice(indexId, 1);
      }
      // 重新获取图片预览 ok
      this.images = [];
      for (const i in this.files) {
        const file = this.files[i];
        if (file.type.startsWith("image")) {
          this.images.push(file.url);
        }
      }
      //移除对应的文件上传任务 ok
      const i = this.uploadControllers.findIndex((item) => item.id === id);
      if (i > -1) {
        // 在这个时候取消请求
        this.uploadControllers[i].controller.abort();
        this.uploadControllers.splice(i, 1);
      }
      //移除对应的待上传文件 ok
      const waitId = this.filesWaitUpload.findIndex((item) => item.id === id);
      if (waitId > -1) {
        this.filesWaitUpload.splice(waitId, 1);
      }
      //移除对应的上传成功的本地会话预览文件 ok
      const completeId = this.completeFiles.findIndex((item) => item.id === id);
      if (completeId > -1) {
        this.completeFiles.splice(completeId, 1);
      }
      console.log("点击了删除按钮2");
      //将数据告知父组件
      this.$emit(
        "sendFilesWaitUpload",
        this.filesWaitUpload,
        this.completeFiles
      );
    },

    // 上传文件的方法
    uploadFile(file) {
      const controller = new AbortController();
      this.uploadControllers.push({ controller: controller, id: file.id });
      const formData = new FormData();
      formData.append("ai_app_code", this.ai_app_code);
      formData.append("file", file.file);
      // 设置请求头
      const headers = {
        "Content-Type": "multipart/form-data",
        appId: window.localStorage.getItem("appId_AI"),
        sessionId: window.localStorage.getItem("sessionId_AI"),
      };
      axios
        .post("./aiGateway/ai/file/upload", formData, {
          headers: headers,
          signal: controller.signal, // 用于取消请求
          onUploadProgress: (progressEvent) => {
            // 计算上传进度百分比
            if (progressEvent.total !== null && file.type != "image") {
              const progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              // 可以更新对应文件的上传进度
              const i = this.files.findIndex((item) => item.id === file.id);
              if (i > -1) {
                this.$set(this.files[i], "progress", Number(progress));
              }
            }
          },
        })
        .then((response) => {
          //移除对应的文件上传任务
          const i = this.uploadControllers.findIndex(
            (item) => item.id === file.id
          );
          if (i > -1) {
            this.uploadControllers.splice(i, 1);
          }
          //格式化数据 对齐需通过ws上传给服务器的数据格式
          if (response.data.data) {
            let data = {};
            data.type = response.data.data.type;
            data.transfer_method = "local_file";
            data.upload_file_id = response.data.data.id;
            data.id = file.id;
            this.filesWaitUpload.push(data);
            //用户点击发送按钮后，完成上传的文件push到历史会话
            this.completeFiles.push(file);
            //将数据告知父组件
            this.$emit(
              "sendFilesWaitUpload",
              this.filesWaitUpload,
              this.completeFiles
            );
          } else if (response.data.msg) {
            this.$toast(response.data.msg);
            //移除对应的文件
            this.removeFile(file.id);
          }
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            console.error("文件上传失败终止:", error);
          } else {
            this.$toast("文件上传失败");
            console.error("文件上传失败:", error);
          }
          //移除对应的文件
          this.removeFile(file.id);
        });
    },
    // ------------------------绘制svg start--------------------------
    getPath(startPercent, endPercent) {
      const startAngle = (startPercent / 100) * 360;
      const endAngle = (endPercent / 100) * 360;
      const start = this.polarToCartesian(1, startAngle);
      const end = this.polarToCartesian(1, endAngle);
      const largeArcFlag = endAngle - startAngle <= 180 ? "0" : "1";

      return [
        "M",
        start.x,
        start.y,
        "A",
        1,
        1,
        0,
        largeArcFlag,
        1,
        end.x,
        end.y,
        "L",
        0,
        0,
      ].join(" ");
    },
    polarToCartesian(radius, angleInDegrees) {
      const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

      return {
        x: radius * Math.cos(angleInRadians),
        y: radius * Math.sin(angleInRadians),
      };
    },
    // ------------------------绘制svg end--------------------------
    //获取图片预览的index
    getPreviewIndex(id) {
      const i = this.files.findIndex((item) => item.id === id);
      if (i > -1) {
        const j = this.images.findIndex((item) => item === this.files[i].url);
        if (j > -1) {
          this.previewIndex = j;
        }
      }
      this.showPreview = true;
    },
    //点击预览，获取video的url并展示预览效果
    previewItem(item) {
      //video的预览
      if (item.type.startsWith("video")) {
        if (item.transfer == "remote") {
          //来自远程链接，直接设置url
          this.videoUrl = item.url;
          this.showVideoPopup = true;
        } else {
          // 清理内存
          // 本地文件，使用 URL.createObjectURL
          if (this.videoUrl && this.videoUrl.startsWith("blob:")) {
            // 确保只对 Blob URL 调用 revokeObjectURL
            URL.revokeObjectURL(this.videoUrl);
          }
          // 创建一个临时的URL，用于视频预览 适用于本地文件（选择上传后/本地push到会话列表中的文件）
          this.videoUrl = URL.createObjectURL(item.file);
          if (this.videoUrl) {
            this.showVideoPopup = true;
          }
        }
      }
      //audio的预览
      if (item.type.startsWith("audio")) {
        if (item.transfer == "remote") {
          //来自远程链接，直接设置url
          this.audioUrl = item.url;
          this.showAudioPopup = true;
        } else {
          // 清理内存
          // 本地文件，使用 URL.createObjectURL
          if (this.audioUrl && this.audioUrl.startsWith("blob:")) {
            // 确保只对 Blob URL 调用 revokeObjectURL
            URL.revokeObjectURL(this.audioUrl);
          }
          // 创建一个临时的URL，用于音频预览 适用于本地文件（选择上传后/本地push到会话列表中的文件）
          this.audioUrl = URL.createObjectURL(item.file);
          console.log("Generated audio URL:", this.audioUrl); // 添加这行代码检查生成的 URL
          if (this.audioUrl) {
            this.showAudioPopup = true;
          }
        }
      }
    },
    //获取视频的封面图，时长
    getVideoCoverAndDuration(videoFile) {
      // 创建一个隐藏的 video 元素
      const videoElement = document.createElement("video");
      videoElement.src = URL.createObjectURL(videoFile.file); // 设置视频源
      videoElement.preload = "metadata"; // 预加载元数据
      // 监听 loadedmetadata 事件（当视频元数据加载完成时触发）
      videoElement.addEventListener("loadedmetadata", () => {
        // 获取视频时长（单位：秒）
        const videoDuration = Math.floor(videoElement.duration);
        const i = this.files.findIndex((item) => item.id === videoFile.id);
        if (i > -1) {
          this.$set(this.files[i], "videoDuration", Number(videoDuration));
        }
        // 延迟设置 currentTime
        setTimeout(() => {
          videoElement.currentTime = 0;
        }, 100);
      });

      videoElement.addEventListener("seeked", () => {
        console.log("seeked 事件触发");
        if (videoElement.videoWidth > 0 && videoElement.videoHeight > 0) {
          const canvas = document.createElement("canvas");
          canvas.width = videoElement.videoWidth;
          canvas.height = videoElement.videoHeight;
          const ctx = canvas.getContext("2d");
          ctx.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
          // 检查获取到的帧图片是否为黑屏，部分机型可能存在问题，检测到黑屏返回error
          const isBlackScreen = this.checkIfCanvasIsBlack(canvas);
          // if (isBlackScreen) {
          //   console.error("检测到黑屏");
          //   const i = this.files.findIndex(item => item.id === videoFile.id);
          //   if (i > -1) {
          //     this.$set(this.files[i], 'load', 'error');
          //   }
          // } else {
          const coverImage = canvas.toDataURL("image/jpeg");
          const i = this.files.findIndex((item) => item.id === videoFile.id);
          if (i > -1) {
            this.$set(this.files[i], "coverImage", coverImage);
            this.$set(this.files[i], "load", "success");
          }
          // }
        } else {
          console.error("视频宽高未正确加载");
          const i = this.files.findIndex((item) => item.id === videoFile.id);
          if (i > -1) {
            this.$set(this.files[i], "load", "error");
          }
        }

        // 释放资源
        videoElement.removeEventListener("loadedmetadata", () => {});
        videoElement.removeEventListener("seeked", () => {});
        videoElement.removeEventListener("error", () => {});
        URL.revokeObjectURL(videoElement.src);
      });
      // 监听视频加载错误
      videoElement.addEventListener("error", () => {
        console.error("视频加载失败：文件可能损坏或格式不支持。");
        const i = this.files.findIndex((item) => item.id === videoFile.id);
        if (i > -1) {
          this.$set(this.files[i], "load", "error");
        }
        // 释放资源
        videoElement.removeEventListener("loadedmetadata", () => {});
        videoElement.removeEventListener("seeked", () => {});
        videoElement.removeEventListener("error", () => {});
        URL.revokeObjectURL(videoElement.src);
      });
      // 加载视频
      videoElement.load();
    },
    // 检测 Canvas 是否为黑屏
    checkIfCanvasIsBlack(canvas) {
      const ctx = canvas.getContext("2d");
      const imageData = ctx.getImageData(
        0,
        0,
        canvas.width,
        canvas.height
      ).data;
      // 随机采样像素点，避免遍历所有像素
      const sampleCount = 100; // 采样点数量
      const totalPixels = canvas.width * canvas.height;
      for (let i = 0; i < sampleCount; i++) {
        const randomIndex = Math.floor(Math.random() * totalPixels) * 4; // 每个像素有 4 个通道 (RGBA)
        const r = imageData[randomIndex];
        const g = imageData[randomIndex + 1];
        const b = imageData[randomIndex + 2];

        // 如果存在非黑色像素点，则不是黑屏
        if (r !== 0 || g !== 0 || b !== 0) {
          return false;
        }
      }
      // 所有采样点均为黑色，则认为是黑屏
      return true;
    },
    // 格式化时间为 MM:SS 格式
    formatTime(seconds) {
      const minutes = Math.floor(seconds / 60); // 计算分钟数
      const remainingSeconds = seconds % 60; // 计算剩余秒数
      // 格式化分钟和秒数
      const formattedMinutes = String(minutes); // 分钟部分不需要补零
      const formattedSeconds = String(remainingSeconds).padStart(2, "0"); // 秒数补零
      return `${formattedMinutes}:${formattedSeconds}`;
    },
  },
  beforeDestroy() {
    if (this.videoUrl && this.videoUrl.startsWith("blob:")) {
      URL.revokeObjectURL(this.videoUrl);
    }
    if (this.audioUrl && this.audioUrl.startsWith("blob:")) {
      URL.revokeObjectURL(this.audioUrl);
    }
  },
};
</script>
<style scoped lang="scss">
@import "filePreviewForPC";
</style>
